"use client"

import * as React from "react"
import { cn } from '../../../../lib/utils'
import { gridLoaderVariants } from "../constants"
import type { GridLoaderProps } from "../types"

const GridLoader = React.forwardRef<HTMLDivElement, GridLoaderProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div ref={ref} className={cn(gridLoaderVariants(), className)} {...props}>
        {children || (
          <>
            {/* Ring drawn with SVG strokes, not `border-2` + a transparent top
                edge (`docs/borderless-contract.md` §5) — same 20px spinner. */}
            <svg
              aria-hidden="true"
              viewBox="0 0 24 24"
              fill="none"
              className="size-5 animate-spin text-accent"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeOpacity="0.25"
                strokeWidth="2.5"
              />
              <path
                d="M22 12a10 10 0 0 0-10-10"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
              />
            </svg>
            <span className="text-sm">Loading more...</span>
          </>
        )}
      </div>
    )
  }
)

GridLoader.displayName = "GridLoader"

export { GridLoader }
